import React, { useEffect, useLayoutEffect, useRef, useState, useTransition } from 'react'
import Header from '../../Dashboard/SubComponents/Header'
import { Button } from "../../../../../src/components/ui/button"
import { Slider } from "../../../../../src/components/ui/slider"
import { Upload, ImageIcon, ImageDown, Download, Link } from "lucide-react"
import { Textarea } from "../../../../../src/components/ui/textarea"
import Loader from '../../../Loader/Loader';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "../../../../../src/components/ui/select"
import BuilderService from '../../../../../src/Site/services/BuilderService'
import { send } from 'process'
import { toast } from "react-toastify";
import ReCAPTCHA from "react-google-recaptcha";
import { LimitExceedPopup } from './LimitExccedPopup'

type EditorStateType= {
    image: File | null;
    prompt: string;
    photoStyleType: string;
    photoStyleTypeDesc: string;
    size: string;
    quality: string;
    noOfOutput: number;
  }



const styleOptions = [
  { id: 1, thumbnail: "https://img.freepik.com/premium-photo/highdetail-photorealistic-realism_1168612-252710.jpg", name: "Photorealistic" },
  {
    id: 2,
    thumbnail: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcShkBVD6GiSGQcbjJILQTloo_floHqRFz1IHA&s",
    name: "Artistic",
  },
  {
    id: 3,
    thumbnail: "https://i.etsystatic.com/5132238/r/il/a9f9c3/370440365/il_570xN.370440365_h2hf.jpg",
    name: "Abstract",
  },
  {
    id: 4,
    thumbnail: "https://img.freepik.com/free-photo/3d-rendering-cartoon-boy_23-2150797600.jpg?semt=ais_hybrid&w=740",
    name: "Cartoon",
  },
]


const qualityOptions = [
  { value: "auto", label: "Auto" },
  { value: "low", label: "Low" },
  { value: "medium", label: "Medium" },
  { value: 'high', label: "High" },
]

const ImageEditor = () => {
  const builderService = new BuilderService();
   const [limits,setLimits] = useState<number | null>(null)
  const imageRef = useRef<HTMLInputElement | null>(null)
  const [loading, setLoading] = useState(false)
   const [showLimitPopup,setShowLimitPopup] = useState(false)
  const [imageStyle, setImageStyle] = useState<number | null>(null)
  const [quality, setQuality] = useState("low")
   const recaptchaRef = useRef<ReCAPTCHA>(null);
  const [selectedSize, setSelectedSize] = useState("auto")
  const [noOfOutput, setNoOfOutput] = useState(1)
  const [response, setResponse] = useState<any>(null)
  const [error, setError] = useState(false)
  const [formState, setFormState] = useState<EditorStateType>({
    image: null,
    prompt: "",
    photoStyleType: '',
    photoStyleTypeDesc: '',
    size: "auto",
    quality: "low",
    noOfOutput: 1,
  });


  function openInputFile() {
    if (imageRef.current) imageRef.current?.click()
  }

  function handleImageUpload() {
    setError(false);
    setResponse(null);
   
    if (imageRef.current?.files && imageRef.current.files.length > 0) {
      const file = imageRef.current.files[0];
      console.log(file)
      const extension = file.name.split('.').pop()?.toLowerCase();
      const disallowedExtensions = ['jpg']
      if (extension && disallowedExtensions.includes(extension)) {
        setError(true);
        return;
      }

      if (file.size > 25 * 1024 * 1024) {
        toast.error("File size should be less than 25MB");
        return;
      }

      setResponse(null);
      setFormState((prev: any) => ({
        ...prev,
        image: file
      }));
    }
  }

  const handleChangeValue = (e: React.ChangeEvent<HTMLTextAreaElement | HTMLInputElement>) => {
    return setFormState({ ...formState, [e.target!.name]: e.target!.value })
  }



    useLayoutEffect(() => {
      (async()=>{
        const builderService = new BuilderService();
       const limits = await builderService.leftAgentCreditLimit();
        if(limits.success){
          setLimits(limits.credit)
        }
      })()
    }, [])
  


    useEffect(() => {
        const timer = setTimeout(() => {
          if (recaptchaRef.current) {
            try {
              recaptchaRef.current.execute();
            } catch (error) {
              console.error("Error executing reCAPTCHA:", error);
            }
          }
        }, 1000);
      
        return () => clearTimeout(timer);
      }, []);
 
  async function onSubmit() {
    setLoading(true);
    setLimits((prev:any)=> prev < 3 ? prev+=1 : prev)
    if ((!response?.aiImagePath && !formState.image)) {
      toast.error("Image is Required to perform operation's")
      setLoading(false)
      return
    }
    try {
      const formData = new FormData();
      if (formState.image) {
        formData.append("image", formState.image);
      }
      formData.append("prompt", formState.prompt);
      formData.append("photoStyleType", formState.photoStyleType);
      formData.append("photoStyleTypeDesc", formState.photoStyleTypeDesc);
      formData.append("size", formState.size);
      formData.append("quality", formState.quality);
      formData.append('noOfOutput', formState.noOfOutput.toString())
      formData.append("isExistingImg", response?.aiImagePath ? response?.aiImagePath : "false");
      // formData.append("isExistingImg", response?.aiImagePath ?
      //   Array.isArray(response?.aiImagePath) ?response?.aiImagePath[0]: response?.aiImagePath 
      //    : "false");
      const res = await builderService.aIImageEditor(formData);
      console.log(res)
      if (res.success) {
        setResponse(res);
        setQuality('low')
        setFormState({
          image: null,
          prompt: "",
          photoStyleType: '',
          photoStyleTypeDesc: '',
          size: "auto",
          quality: "low",
          noOfOutput: 1,
        });
        if (imageRef.current) {
          imageRef.current.value = ''
        }
      }
       else {
        if (res?.limitExceeded) {
          setShowLimitPopup(true)
        }else{
          toast.error(res?.error || res?.message, {
            autoClose: 5000,
          })
        }
              
      }

    } catch (error: any) {
      console.log(error.message, 12)
      toast.error(error || error.message);
    } finally {
      setLoading(false);
      setNoOfOutput(1);

    }
  }


  function downloadAllImage() {
    if (!response.images.length) return toast.error("No images to download")
    response.images.forEach((image: string, idx: number) => {
      const img = document.createElement('a')
      img.href = image
      img.download = `image-${idx + 1}.png`
      document.body.appendChild(img)
      img.click()
      document.body.removeChild(img)
    })
  }

  const handleCopyImage = async (imgSource: string) => {
    const base64 = imgSource.split(',')[1];
    const binaryString = atob(base64);
    const bytes = new Uint8Array(binaryString.length);
    for (let i = 0; i < binaryString.length; i++) {

      bytes[i] = binaryString.charCodeAt(i);
    }
    const blob = new Blob([bytes], { type: 'image/png' });
    const data = [
      new ClipboardItem({
        'image/png': new Promise((resolve) => (resolve(blob)))
      })
    ]
    await navigator.clipboard.write(data);
    toast.success("Image copied to clipboard")
  }


  useEffect(() => {
    const handleBeforeUnload = (event: BeforeUnloadEvent) => {
      if (loading) {
        event.preventDefault();
        event.returnValue = '';
      }
    };

    window.addEventListener('beforeunload', handleBeforeUnload);

    return () => {
      window.removeEventListener('beforeunload', handleBeforeUnload);
    };
  }, [loading]);


  return (
    <div className="flex flex-col min-h-svh prompt-gallery">
      <Header />
      {
        showLimitPopup && <LimitExceedPopup title='Limit Exceed' subTitle='You have reached your free limit.' setShowLimitPopup={setShowLimitPopup} />
      }
      <div className="flex-1 px-4 py-6 md:px-6 md:py-8 max-w-6xl mx-auto w-full">
        <div className="text-center mb-6">
          <h2 className="text-2xl font-bold mb-1">
            <span className="text-pink-500">AI</span> Image Editor
          </h2>
          <p className="text-gray-400 text-sm">Edit images with the power of AI - fast, smart, and intuitive</p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-4 bg-zinc-900/80 rounded-lg p-4 border border-zinc-800">
          {/* Left Panel */}

          <div className="space-y-6 bg-zinc-900 rounded-lg p-4 border border-zinc-800">
            {/* Upload */}
            <div
              onClick={openInputFile}
              className="border border-dashed border-pink-500/30 rounded-lg p-4 flex flex-col items-center justify-center bg-zinc-900/50 cursor-pointer hover:bg-zinc-800/50 transition-colors py-10"
            >
              <input onChange={handleImageUpload} ref={imageRef} type="file" name="image" accept="image/png, image/webp, image/jpeg" hidden />
              <div className="w-12 h-12 rounded-lg bg-pink-500/10 flex items-center justify-center mb-2">
                <Upload className="w-6 h-6 text-pink-500" />
              </div>
              <p className="text-sm font-medium">Upload Image</p>
              {
                formState.image ? (
                  <p className="text-xs text-gray-400">{formState.image.name}</p>
                ) : (
                  <p className="text-xs text-gray-400">PNG, JPEG or WEBP (max size 25 MB)</p>
                )
              }

            </div>
            {error && (
              <p className="text-xs text-red-500">
                Supported file formats are PNG, JPEG, and WEBP only.
              </p>
            )}

            <div>
              <p className="text-xs font-semibold mb-2">DESCRIBE YOUR IMAGE</p>
              <Textarea
                name="prompt"
                value={formState.prompt}
                onChange={handleChangeValue}
                placeholder="What do you want to see?"
                className="bg-zinc-800 border-zinc-700 text-sm resize-none h-24" />
            </div>

            {/* Styles */}
            <div>
              <p className="text-xs font-semibold text-gray-400 mb-2">STYLE</p>
              <div className="grid grid-cols-4 gap-2">
                {styleOptions.map((style, idx: number) => (
                  // border-pink-500
                  <div
                    onClick={() => {
                      setImageStyle(idx);
                      setFormState(prev => ({
                        ...prev,
                        photoStyleType: style.name,
                      }));
                    }}
                    key={style.id} className="cursor-pointer relative ">
                    <div className={`rounded-lg overflow-hidden  transition-all ${idx === imageStyle ? 'border-pink-500 border-2' : 'border-none border-transparent'}`}>
                      <img src={style.thumbnail} alt={style.name} className="w-full aspect-square object-cover" />
                    </div>
                    <span className='absolute top-1 right-1 text-xs font-semibold text-white bg-black/60 rounded-full px-2 py-1'>{style.name}</span>
                  </div>
                ))}
              </div>
              <div className="mt-2">
                <Textarea
                  placeholder="Write a visual style"
                  name="photoStyleTypeDesc"
                  value={formState.photoStyleTypeDesc}
                  onChange={handleChangeValue}
                  className="bg-zinc-800 border-zinc-700 text-sm resize-none h-12"
                />
              </div>
            </div>
            {/* Size */}
            <div>
              <p className="text-xs font-semibold text-gray-400 mb-2">SIZE</p>
              <div className="grid grid-cols-4 gap-2">
                {['Auto', '1:1', '3:2', '2:3'].map((size) => (
                  <Button
                    key={size}
                    variant={selectedSize === size.toLowerCase() ? 'default' : 'outline'}
                    className={`${selectedSize === size.toLowerCase() ? 'bg-zinc-700 border-zinc-600' : 'bg-zinc-800 border-zinc-700'} hover:bg-zinc-700`}
                    onClick={() => {
                      const sizeValue = size === 'auto' ? 'auto' : size;
                      setSelectedSize(sizeValue);
                      setFormState(prev => ({ ...prev, size: sizeValue.toLowerCase() }));
                    }}
                  >
                    {size}
                  </Button>
                ))}
              </div>
            </div>

            {/* Quality & Outputs */}
            <div className="grid grid-cols-5 space-x-3 items-center">
              <div className="col-span-2">
                <div className="flex justify-between mb-2">
                  <p className="text-xs font-semibold text-gray-400">QUALITY</p>
                </div>
                <Select
                  value={quality}
                  onValueChange={(val) => {
                    setQuality(val);
                    setFormState(prev => ({ ...prev, quality: val }));
                  }}
                >
                  <SelectTrigger className="w-full bg-zinc-800 border-zinc-700 text-white focus:ring-pink-500">
                    <SelectValue placeholder="Select quality" />
                  </SelectTrigger>
                  <SelectContent className="bg-zinc-800 border-zinc-700 text-white">
                    {qualityOptions.map((option) => (
                      <SelectItem
                        key={option.value}
                        value={option.value}
                        className="focus:bg-zinc-700 focus:text-white"
                      >
                        {option.label}
                      </SelectItem>
                    ))}
                  </SelectContent>
                </Select>
              </div>

              <div className="col-span-3">
                <div className="flex justify-between mb-2">
                  <p className="text-xs font-semibold text-gray-400">NO. OF OUTPUTS</p>
                  <div className="flex items-center gap-2">
                    <Button variant="ghost" size="sm" className="h-6 px-2 text-xs" onClick={() => {
                      const newVal = Math.max(1, noOfOutput - 1);
                      setNoOfOutput(newVal);
                      setFormState(prev => ({ ...prev, noOfOutput: newVal }));
                    }}>-</Button>
                    <span className="text-xs">{noOfOutput}</span>
                    <Button variant="ghost" size="sm" className="h-6 px-2 text-xs" onClick={() => {
                      const newVal = Math.min(4, noOfOutput + 1);
                      setNoOfOutput(newVal);
                      setFormState(prev => ({ ...prev, noOfOutput: newVal }));
                    }}>+</Button>
                  </div>
                </div>
                <Slider
                  value={[noOfOutput]}
                  min={1}
                  max={4}
                  step={1}
                  onValueChange={(val) => {
                    setNoOfOutput(val[0]);
                    setFormState(prev => ({ ...prev, noOfOutput: val[0] }));
                  }}
                  className="py-1"
                />
              </div>
            </div>

            <div className='flex justify-end'>
            <ReCAPTCHA
            size='invisible'
              sitekey={'6LeIxAcTAAAAAJcZVRqyHh71UMIEGNQ_MXjiZKhI'} 
            />

</div>

            <Button disabled={error || loading || !formState.prompt.trim().length || formState.prompt.trim().length < 5} onClick={onSubmit} className="w-full bg-pink-600 hover:bg-pink-700 text-white">Generate</Button>
            <p className="text-xs text-gray-400 ">Credits Used: {limits}/3</p>
          </div>

          {/* Right Panel */}
          <div className="bg-zinc-900 rounded-lg relative flex items-center justify-center p-4 border border-zinc-800 min-h-[400px] overflow-y-auto  flex-col">
            <div className='flex-1 justify-center items-center flex'>
              {
                response ?
                  loading && response.aiImagePath ? <Loader isLoading={loading} imageUrl="https://dlvkyia8i4zmz.cloudfront.net/JllcrYgcTSeRguZ1fEhe_advance_t_b__2___3_.svg" text="" /> :
                    response && response.image ? (
                      <img src={response.image} alt="Generated Image" className="w-full h-full object-contain rounded-lg" />
                    ) : response && response.images && Array.isArray(response.images) ? (
                      <div className="grid grid-cols-1 gap-4">
                        {response.images.map((img: string, idx: number) => (
                          <div className='relative' key={idx}>
                            <a href={img} download style={{ all: 'unset' }}>
                              <div className='absolute top-2 right-2 cursor-pointer bg-pink-500 hover:bg-pink-600 p-2 rounded-full'>
                                <ImageDown className='w-5 h-5 ' />
                              </div>
                            </a>
                            <img key={idx} src={img} alt={`Generated ${idx}`} className="w-full h-auto rounded-lg" />
                          </div>
                        ))}
                      </div>) : ''
                  :
                  loading ? <div className='absolute inset-0'>
                    <Loader isLoading={loading} imageUrl="https://dlvkyia8i4zmz.cloudfront.net/JllcrYgcTSeRguZ1fEhe_advance_t_b__2___3_.svg" text="" />
                  </div> :
                    formState && formState?.image ?
                      <img src={URL.createObjectURL(formState.image)} alt="Generated Image" className="w-full h-full object-contain rounded-lg" />
                      : <div className="text-center">
                        <div className="w-16 h-16 rounded-lg bg-pink-500/10 flex items-center justify-center mx-auto mb-4">
                          <ImageIcon className="w-8 h-8 text-pink-500" />
                        </div>
                        <h3 className="text-lg font-medium mb-2">Your creations will appear here</h3>
                        <p className="text-sm text-gray-400 max-w-xs mx-auto">
                          Generate your first AI image by filling out the form and clicking the Generate button.
                        </p>
                      </div>

              }
            </div>
            {/*  buttons */}
            {
              response && (response.images || response.image) && (
                <div className='flex justify-center gap-4 mt-8'>
                  {
                    response.images ?
                      <Button
                        onClick={downloadAllImage}
                        className='bg-pink-600 text-white hover:bg-pink-700 rounded-xl'>
                        <Download className='w-5 h-5' />
                        Download All
                      </Button>
                      :
                      <a
                        download
                        href={response?.image}
                        className='bg-pink-600 text-white cursor-pointer text-sm hover:bg-pink-700 rounded-xl flex items-center gap-2 px-4 py-2'
                      >
                        <Download className='w-5 h-5' />
                        Download
                      </a>
                  }
                  <Button
                  disabled={response?.images?.length } // <= not parmanent
                    onClick={() => { handleCopyImage(response?.image) }}
                    className='border-pink-600 hover:bg-transparent text-white cursor-pointer text-sm border bg-transparent rounded-xl flex items-center gap-2 px-4 py-2'
                  >
                    <Link className='w-5 h-5 ' />
                    Copy URL
                  </Button>
                </div>

              )
            }
          </div>
        </div>
      </div>
    </div>
  );
}

export default ImageEditor

